import { render, staticRenderFns } from "./headerStatusFilter.vue?vue&type=template&id=10980bff&scoped=true"
import script from "./headerStatusFilter.vue?vue&type=script&lang=js"
export * from "./headerStatusFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10980bff",
  null
  
)

export default component.exports